<template>
  <div>
    <v-toolbar
      flat
      :color="entityConfig.header1Color"
      height="40px"
      v-if="isLoggedIn"
    >
      <v-container>
        <v-btn
          alt="Salir"
          style="min-width: 0px"
          text
          dark
          class="float-end"
          @click="openDialog()"
        >
          <v-icon small dark>mdi-logout</v-icon>
        </v-btn>
        <v-btn
          text
          dark
          @click="$router.push('/gestion-de-usuarios/perfil')"
          class="float-end"
        >
          <v-icon left dark> mdi-account-outline </v-icon>
          {{ username }}
        </v-btn>
        <div class="float-end px-4 text-white"><div style="padding: 5px 10px">{{userdata.supplierId}}</div></div>
      </v-container>
    </v-toolbar>
    <v-toolbar flat :color="entityConfig.header2Color" height="100px">
      <v-container>
        <v-row v-resize="onResize">
          <v-col cols="6" sm="6" md="2">
            <a @click="$router.push('/home')">
              <img
                width="200px"
                :src="entityConfig.primaryLogoUrl"
                class="header-brand-img"
                alt="logo"
              />
            </a>
          </v-col>
          <v-col cols="6" sm="6" md="10">
            <!--Desktop Menu-->
            <div v-show="!isMobile" class="custom-navbar float-end">
              <ul>
                <li v-for="link of links" v-bind:key="link.name">
                  <router-link
                    :to="link.target"
                    v-slot="{ href, navigate, isActive, isExactActive }"
                    custom
                  >
                    <a
                      :style="[
                        (isActive || isExactActive)
                          ? {
                              color: entityConfig.secondaryColor,
                              'border-bottom': `3px solid ${entityConfig.secondaryColor}`,
                            }
                          : { color: entityConfig.primaryContrastColor },
                      ]"
                      :href="href"
                      @click="navigate"
                      @mouseover="setColor(entityConfig.secondaryColor, $event)"
                      @mouseout="
                        setColor(
                          isActive
                            ? entityConfig.secondaryColor
                            : entityConfig.primaryContrastColor,
                          $event
                        )
                      "
                      >{{ link.name }}</a
                    >
                  </router-link>
                </li>
              </ul>
            </div>

            <v-menu offset-y close-on-click>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-show="isMobile"
                  text
                  dark
                  class="float-end"
                  style="text-transform: lowercase !important"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark> mdi-menu </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  link
                  v-for="link of links"
                  v-bind:key="link.name"
                  @click="$router.push(link.target)"
                >
                  <v-list-item-title>{{ link.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-container>
    </v-toolbar>
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title>
        <v-spacer></v-spacer>
      </v-card-title>
        <v-card-text>
          <p class="text-body-1 ">
            ¿Estas seguro que deseas cerrar la sesión?
          </p>
          </v-card-text>
        <v-card-actions class="card-action-with-space">
          <v-spacer></v-spacer>
          <v-btn outlined depressed :color="entityConfig.primaryColor"  @click="dialog = false">
            Cancelar
          </v-btn>
          <v-btn dark depressed :color="entityConfig.primaryColor" 
          :style="`color: ${entityConfig.secondaryColor}`" 
          @click="dialog = false; logout();">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "../../../Services/index";

export default {
  data() {
    return {
      dialog: false,
      isLoggedIn: false,
      isMobile: false,
      username: "",
      userdata: {},
      entityConfig: {},
      links: [
        {
          name: this.$t("nav.invoices"),
          target: "/facturas",
        },
        {
          name: this.$t("nav.invoiceAdvance"),
          target: "/anticipo-facturas",
        },
        {
          name: this.$t("nav.autoAdvance"),
          target: "/anticipo-automatico",
        },
        {
          name: this.$t("nav.bankAccounts"),
          target: "/cuentas-de-abono",
        },
        {
          name: this.$t("nav.personalDataManagement"),
          target: "/gestion-de-proveedores",
        },
      ],
    };
  },
  components: {},
  mounted() {
    this.onResize();
    this.entityConfig = this.$store.state.entityConfig.config;
    this.userdata = JSON.parse(sessionStorage.getItem("userData"));
    this.username = sessionStorage.getItem("alias");
    this.isLoggedIn = this.userdata.email.length > 0;

    // Cerrar Sesion en caso de codigo de error 651
    Api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response.status === 401 && error.response.data.code === 651) {
          console.log("Sesion cerrada por inactividad");
          sessionStorage.removeItem("codNrbeEn");
          sessionStorage.removeItem("authtoken");
          sessionStorage.removeItem("alias");
          sessionStorage.removeItem("userData");
          this.$router.push({ name: "Login" });
          window.location.reload();
        }
        return Promise.reject(error);
      }
    );
  },
  onIdle() {
    this.$toast.warning("Sesion cerrada por inactividad");
    setTimeout(() => {
      this.logout();
    }, 10000);
  },
  methods: {
    setColor(color, event) {
      event.target.style.color = color;
    },
    onResize() {
      this.isMobile = window.innerWidth <= 1200;
    },
    logout() {
      sessionStorage.clear();
      this.$router.push({ name: "Login" });
    },
    openDialog() {
      this.dialog = true;
    },
  },
};
</script>

<style lang="scss">
.custom-navbar {
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    align-items: center;
    padding-top: 1em;
  }

  li {
    float: left;
  }

  li a {
    font-size: 0.9em;
    display: block;
    padding: 8px;
    margin: 4px;
    transition: 0.5s;
    text-decoration: none;
  }
}
</style>
